const strings = {
  "appname": "Adventskalender",



}

export default {
  strings
};

